// extracted by mini-css-extract-plugin
export default {"pageContainer":"PrivacyPolicyPage_pageContainer__ZUS74","section":"PrivacyPolicyPage_section__ooZSf","subSection":"PrivacyPolicyPage_subSection__xzPB1"};